import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import usePayment from '../../../../hooks/usePayment';
import PaymentItem from '../../../components/Payment/PaymentItem';
import { resolvePaymentMethodLabel } from '../../../../util/paymentUtils';

function PaymentHistoryModal({ open, onClose, booking }) {
  const { loading, error, getPaymentsByBookingId } = usePayment();
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    if (open && booking?._id) {
      const f = async () => {
        const payments = await getPaymentsByBookingId(booking._id);
        setPayments(payments);
      };
      f();
    }
  }, [open, booking?._id]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant='h6'>Online-Zahlungsverlauf</Typography>
          <IconButton onClick={onClose} size='small'>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display='flex' justifyContent='center' p={3}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color='error' align='center'>
            {error}
          </Typography>
        ) : payments.length === 0 ? (
          <Typography align='center' sx={{ py: 2 }}>
            Keine Zahlungen vorhanden
          </Typography>
        ) : (
          payments.map(payment => (
            <PaymentItem
              key={payment._id}
              payment={payment}
              getPaymentMethod={p => resolvePaymentMethodLabel(p, '')}
            />
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PaymentHistoryModal;
